<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12 vh-header d-flex flex-column">
        <div class="card flex-1-auto h-100 overflow-auto">
            <div class="card-header card-header-with-button">
               <h5>{{$t('ACLGROUPS')}}</h5>
               <button type="button" class="btn-bis btn-primary" @click="showModal()">{{$t('NEW')}}</button>
            </div>
            <div class="card-body" v-if="data.root == null || !data.root.length">
              <p class="center">{{$t('NODATAFOUND')}}</p>
            </div>
            <div class="table-responsive h-100 flex-1-auto" v-if="data.root != null && data.root.length">
              <table class="table table-bis">
                <thead>
                  <tr>
                        <th>{{$t('ID')}}</th>
                        <th>{{$t('GROUPNAME')}}</th>
                        <th>{{$t('ACTION')}}</th>
                    </tr>
                </thead>
                <tbody>
                  <template v-for="(group, g) in data.root">
                    <tr :key="g">
                        <td>{{group.groupId}}</td>
                        <td>{{group.groupName}}</td>
                        <td class="table-buttons">
                            <b-button type="reset" class="btn-table table-btn-tertiary" v-on:click.prevent="showModal(group)">{{$t('EDIT')}}</b-button>
                            <b-button type="reset" class="btn-table table-btn-delete ml-2" v-on:click.prevent="deleteRow(group.groupId)">{{$t('DELETE')}}</b-button>
                        </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
            <div class="table-navigation">
                <nav>
                    <b-pagination align="center" :total-rows="parseInt(data.totalCount)" v-model="pagination.currentPage" :per-page="pagination.limit"></b-pagination>
                </nav>
            </div>
          </div>
        </div>
    </div>
    <b-modal ref="formmodal" centered hide-header ok-title="submit" hide-footer no-close-on-backdrop no-close-on-esc>
        <div class="modal-header">
            <div class="modal-title">
                <h5>{{$t('ACLGROUPS')}}</h5>
            </div>
            <button type="button" aria-label="Close" @click="hideModal()" class="close"><img src="../../../../assets/img/icon-close.svg"></button>
        </div>
      <div class="d-block mt-2 modal-content-inside">
        <neweditfrom v-bind:formData="formData" v-bind:formError="formError" v-bind:aclGroups="data"></neweditfrom>
        <div class="text-center mt-lg">
          <b-btn class="mr-2 btn-bis btn-cancel" @click="hideModal()">{{$t('CANCEL')}}</b-btn>
          <b-btn class="btn-bis btn-primary" @click="submitData(formData)">{{$t('SAVE')}}</b-btn>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import Api from '@/api/admin/acl_groups/AclGroups.js';
import NewEditFrom from './Form.vue';

export default {
    name: 'AclGroups',
    components:
    {
        neweditfrom: NewEditFrom,
    },
    data()
    {
        const me = this;

        me.formDataField = {
            groupName: '',
            copyGroupId: null,
        };

        return {
            loading: true,
            data: {},
            formError: {},
            formData: {...me.formDataField},
            pagination: {
                query: '',
                currentPage: 1,
                limit: 25,
            },
            searchTimeout: false,
        };
    },
    created()
    {
        const me = this;
        me.getData();
    },
    methods:
  {
      async getData()
      {
          const me = this;
          try
          {
              me.loading = true;
              const data = await Api.selectRow(me.getParams);
              if (data.error && data.error === true)
              {
                  throw (data);
              }
              me.data = data;
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
          finally
          {
              me.loading = false;
          }
      },
      async deleteRow(id)
      {
          const me = this;
          me.$store.commit('setModalAlert',
              {
                  text: me.$i18n.t('AREYOUSHURE'),
                  async btnAction()
                  {
                      const data = await Api.deleteRow({ id });
                      me.$notify.notice(data);
                      me.getData();
                  },
              });
      },
      showModal(item)
      {
          const me = this;
          if (typeof item !== 'undefined')
          {
              me.formData = { ...item };
          }
          this.$refs.formmodal.show();
      },
      async submitData(item)
      {
          const me = this;
          try
          {
              me.loading = true;
              if (typeof item.groupId !== 'undefined')
              {
                  item.id = item.groupId;
                  delete (item.groupId);
              }

              const data = await Api.save(item);
              if (data.error)
              {
                  me.formError = data;
                  throw (data);
              }

              me.$notify.notice(data);
              me.getData();
              me.hideModal();
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
          finally
          {
              me.loading = false;
          }
      },
      hideModal()
      {
          const me = this;

          me.formError = {};
          me.formData = {...me.formDataField},
          this.$refs.formmodal.hide();
      },
  },
    watch:
    {
        pagination:
        {
            deep: true,
            handler()
            {
                const me = this;

                if (me.searchTimeout !== false)
                {
                    clearTimeout(me.searchTimeout);
                }

                me.searchTimeout = setTimeout(() =>
                {
                    me.getData();
                    me.searchTimeout = false;
                }, 300);
            },
        },
    },
    computed:
  {
      ...mapGetters([
          'globals',
      ]),
      getParams()
      {
          const me = this;
          const data = { ...me.pagination };
          data.start = (data.currentPage - 1) * data.limit;
          return data;
      },
  },
};
</script>
